import React from "react";
import { withTranslation } from "react-i18next";
import { ModalDialog } from "../../../commonjs/modals";

const _ModalEnableCompanyUsers = ({ t, users, handleCancel, handleOk }) => {
  return (
    <ModalDialog
      isOpen={true}
      handleOk={handleOk}
      handleCancel={handleCancel}
      isCriticalAction={true}
      title={t("Enable deactivated company users")}
    >
      <div className="grid__item xs-12">
        {t("Do you want to enable the selected company users")}:
      </div>
      <div className="grid__item xs-12">
        <br />
        {users &&
          users.map((user, id) => {
            return (
              user.value &&
              user.value === true && (
                <span key={id}>
                  <em>
                    {user.first_name} {user.last_name} ({user.email})
                  </em>
                </span>
              )
            );
          })}
        <br />
      </div>
      <div className="grid__item xs-12">
        {t(
          "Please note, that on activation an email will be sent to the provisioning manager."
        )}
      </div>
    </ModalDialog>
  );
};

export const ModalEnableCompanyUsers = withTranslation()(
  _ModalEnableCompanyUsers
);
